interface Props {
  className: any;
}

export const Swapicon4 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32.9577 17.5641V20.9808C32.9577 24.1523 31.6978 27.194 29.4552 29.4366C27.2125 31.6792 24.1709 32.9391 20.9993 32.9391M20.9993 32.9391C17.8278 32.9391 14.7862 31.6792 12.5435 29.4366C10.3009 27.194 9.04102 24.1523 9.04102 20.9808V17.5641M20.9993 32.9391V38.0641M20.9993 3.89746C19.6401 3.89746 18.3365 4.43741 17.3754 5.39854C16.4143 6.35966 15.8743 7.66323 15.8743 9.02246V20.9808C15.8743 22.34 16.4143 23.6436 17.3754 24.6047C18.3365 25.5658 19.6401 26.1058 20.9993 26.1058C22.3586 26.1058 23.6621 25.5658 24.6233 24.6047C25.5844 23.6436 26.1243 22.34 26.1243 20.9808V9.02246C26.1243 7.66323 25.5844 6.35966 24.6233 5.39854C23.6621 4.43741 22.3586 3.89746 20.9993 3.89746Z"
        stroke="#657D84"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}; 